import { FC }  from 'react';
import { SpheraTooltip } from '@sphera-cloud/component-ui-reactjs';
import _ from 'lodash';
import './styles.scss';

interface TruncateTextSimpleProps {
  text: string;
  tooltipText?: string;
}

export const TruncateTextSimple: FC<TruncateTextSimpleProps> = ({ text, tooltipText }) => {
  return (
    <div
      className='target truncate-text-component'
      title={_.isEmpty(tooltipText) ? text: tooltipText }
      data-testid="truncate-text-simple"
    >
        <div className="target-title" >
          <SpheraTooltip anchor="target" position="top">
            {text}
            </SpheraTooltip>  
        </div>
     </div>
  );
};